module.exports = __webpack_public_path__ + "static/media/grayClover.382a7e15.svg";